var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header" }, [
            _c("h5", [
              _vm._v("Список карт "),
              !_vm.showDisabled
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-info pull-right",
                      on: {
                        click: function ($event) {
                          _vm.showDisabled = !_vm.showDisabled
                        },
                      },
                    },
                    [_vm._v("Показать архивные")]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "alert alert-info" }, [
              _vm._v(
                "Таблица с возможностью редактировать порядок активации карт. Кликните на строке и удерживайте кнопку для смены порядка карт."
              ),
            ]),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table table-hover" },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm.records && _vm.records.length
                  ? _c(
                      "draggable",
                      {
                        attrs: { tag: "tbody" },
                        model: {
                          value: _vm.records,
                          callback: function ($$v) {
                            _vm.records = $$v
                          },
                          expression: "records",
                        },
                      },
                      _vm._l(_vm.records, function (record, index) {
                        return _c("tr", { key: record.id }, [
                          _c("td", [
                            _vm._v(_vm._s(index + 1) + " "),
                            _c("i", {
                              staticClass: "icon-fa icon-fa-arrows pointer",
                            }),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(record.id))]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.printCardType(record.type))),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.printNumber(record.number))),
                          ]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(record.owner.short_name))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _vm._v(
                                _vm._s(record.period) + "\n                    "
                              ),
                              !record.in_use
                                ? _c(
                                    "vue-ladda",
                                    {
                                      attrs: {
                                        "button-class":
                                          "ml-1 btn-success btn-xs",
                                        "data-style": "zoom-in",
                                        loading: _vm.loadingBtns[record.id],
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.activateCard(record.id)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Активировать\n                    "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [
                            record.is_active
                              ? _c("span", {
                                  class: `${
                                    record.in_use
                                      ? "badge-success"
                                      : "badge-info"
                                  } badge text-left`,
                                  domProps: {
                                    innerHTML: _vm._s(_vm.printUsage(record)),
                                  },
                                })
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            record.is_active
                              ? _c(
                                  "span",
                                  { staticClass: "badge badge-success" },
                                  [_vm._v("Активна")]
                                )
                              : _c(
                                  "span",
                                  { staticClass: "badge badge-warning" },
                                  [_vm._v("Не активна")]
                                ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-sm btn-info",
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    return _vm.mixinGoToRouter(
                                      "settingsCardsNewEdit",
                                      { id: record.id }
                                    )
                                  },
                                },
                              },
                              [_vm._v("Редактировать")]
                            ),
                          ]),
                        ])
                      }),
                      0
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "text-right" },
              [
                _c(
                  "vue-ladda",
                  {
                    attrs: {
                      "button-class": "btn-success btn",
                      "data-style": "zoom-in",
                      loading: _vm.saveLoading,
                    },
                    on: { click: _vm.saveCardOrder },
                  },
                  [_vm._v("Сохранить порядок\n              ")]
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.showDisabled
          ? _c("div", { staticClass: "card" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _vm.noActive && _vm.noActive.length
                  ? _c("div", [
                      _c("table", { staticClass: "table" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.noActive, function (record, index) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(index + 1))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(record.id))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.printCardType(record.type))),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm.printNumber(record.number))),
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(record.owner.short_name)),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "vue-ladda",
                                    {
                                      attrs: {
                                        "button-class":
                                          "ml-1 btn-success btn-xs",
                                        "data-style": "zoom-in",
                                        loading: _vm.loadingBtns[record.id],
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.activateCard(
                                            record.id,
                                            true
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Сделать активной\n                      "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ])
                  : _c("div", { staticClass: "alert alert-info" }, [
                      _vm._v(
                        "\n              Не активных карт не найдено\n            "
                      ),
                    ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Номер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Имя")]),
        _vm._v(" "),
        _c("th", [_vm._v("Действие (дней)")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Активность")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Не активные карты")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Номер")]),
        _vm._v(" "),
        _c("th", [_vm._v("Имя")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }